import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { ServiceHttpBase } from '../service-http-base.service'
import { DunModel } from 'src/app/models/dun.model';
import { environment } from 'src/environments/environment';
import { UpdateMemberResponseModel } from 'src/app/models/user/update-member-response.model';
import { UpdateMemberModel } from 'src/app/models/update-member.model';
import { MemberModel } from 'src/app/models/member.model';
import { UpdateMemberPhoneNoAndEmailDto } from 'src/app/models/member/update-member-phoneno-and-email';
import { UpdateMemberPhoneNoAndEmailResponseDto } from 'src/app/models/member/update-member-phoneno-and-email-responsedto';

const ACCOUNT_USERS_URL = `${environment.idsUrl}/account`;

@Injectable({
  providedIn: 'root'
})
export class CurrentMemberHttpService  extends ServiceHttpBase {

  //configUrl = this.baseURL + 'clonetype.php';
  configUrl = `${environment.apiUrl}/CurrentMember`;
  idsUrl = `${environment.idsUrl}/Account`;

  constructor(private http: HttpClient) {
    super();
  }

  updateMember(member: MemberModel): Observable<UpdateMemberResponseModel>{
    const url =  this.configUrl + '/UpdateMember';
    //const url =  this.idsUrl + '/UpdateMember';
    //var response = this.http.post<UpdateMemberResponseModel>(`${ACCOUNT_USERS_URL}/UpdateMember`, member);
    var response = this.http.post<UpdateMemberResponseModel>(`${url}`, member);
    return response;
  }

  updateMemberPhoneNoAndEmail(updatePhoneNoAndEmailModel: UpdateMemberPhoneNoAndEmailDto): Observable<UpdateMemberPhoneNoAndEmailResponseDto>{
    const url =  this.idsUrl + '/UpdateMemberPhoneNoAndEmail';
    var response = this.http.post<UpdateMemberPhoneNoAndEmailResponseDto>(url, updatePhoneNoAndEmailModel);
    return response;
  }


}
